import { Button, ButtonProps, Link } from '@mui/material'
import { ReactNode } from 'react'
import { Link as RouterLink } from 'react-router-dom'

interface RouteButtonProps extends ButtonProps {
  children: ReactNode
  to: string
}

export const RouteButton = ({ children, to, ...rest }: RouteButtonProps) => {
  return (
    <Link component={RouterLink} to={to}>
      <Button color='secondary' {...rest}>
        {children}
      </Button>
    </Link>
  )
}
